import React from 'react';
import { Check } from 'lucide-react';

const checks = {
  en: [
    'Skin prep that stays matte under flash',
    'Three makeup paths: daylight, studio, evening',
    'Brows, lips and hair matched to the chosen look',
  ],
  de: [
    'Hautvorbereitung, die unter Blitz matt bleibt',
    'Drei Make-up-Wege: Tageslicht, Studio, Abend',
    'Brauen, Lippen und Haar passend zum gewählten Look',
  ],
};

export default function NutritionSection({ lang }) {
  const t = {
    label: 'Beauty',
    headline:
      lang === 'de'
        ? 'BEAUTY, DIE IM LICHT RUHIG BLEIBT'
        : 'BEAUTY THAT STAYS CALM IN THE LIGHT',
    sub:
      lang === 'de'
        ? 'Pflege und Make-up, notiert für Castings und Editorials, nicht für einen Filter.'
        : 'Skincare and makeup, noted for castings and editorials, not for a filter.',
    cta: lang === 'de' ? 'BEAUTY ÖFFNEN' : 'OPEN BEAUTY',
    statLabel: lang === 'de' ? 'Lichtsettings' : 'Light settings',
  };

  return (
    <section className="bg-rose-50/70 py-20 lg:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="flex flex-col gap-6 order-2 lg:order-1">
            <span className="inline-block w-fit px-4 py-1.5 bg-rose-200 text-rose-950 text-xs font-bold uppercase tracking-widest rounded-full">
              {t.label}
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-stone-900 tracking-tight leading-tight">
              {t.headline}
            </h2>

            <p className="text-stone-500 text-lg leading-relaxed">{t.sub}</p>

            <ul className="flex flex-col gap-4 mt-2">
              {checks[lang].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-7 h-7 rounded-full bg-stone-900 flex items-center justify-center mt-0.5">
                    <Check size={14} color="white" strokeWidth={3} />
                  </div>
                  <span className="text-stone-700 font-medium leading-snug">{item}</span>
                </li>
              ))}
            </ul>

            <div className="pt-2">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-stone-900 hover:bg-rose-950 text-white font-bold rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5"
              >
                {t.cta}
              </a>
            </div>
          </div>

          <div className="relative order-1 lg:order-2 flex justify-center">
            <div className="absolute inset-0 -z-10 bg-gradient-to-br from-rose-200/50 to-stone-200/40 rounded-3xl blur-2xl" />
            <img
              src="https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?auto=format&fit=crop&w=1200&q=80"
              alt={lang === 'de' ? 'Beauty-Portrait mit natürlichem Licht' : 'Beauty portrait in natural light'}
              className="w-full max-w-md h-[400px] lg:h-[480px] object-cover rounded-3xl shadow-2xl"
            />
            <div className="absolute -bottom-4 -right-4 lg:right-0 bg-white rounded-2xl px-5 py-3 shadow-xl border border-stone-100">
              <p className="text-xs text-stone-400 font-medium uppercase tracking-wide">{t.statLabel}</p>
              <p className="text-2xl font-black text-rose-900">3</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
